export default "__VITE_ASSET__aSX2N7DC__"